export const getLicenseFeatures = licenseList => {
  const licenseFeatures = [];
  licenseList?.forEach(license => {
    license.features.forEach(feature => {
      licenseFeatures.push(feature);
    });
  });
  return licenseFeatures;
};
